import { makeStyles } from '@material-ui/core/styles';

export function useCancellationDetailsStyles() {
    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
        },
        backButton: {
            color: '#004B97',
            fontSize: '0.95rem',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
        loading: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            fontSize: '1.2rem',
            color: '#004B97',
        },
    }));

    const classes = useStyles();

    return {
        classes,
    };
}